export default __webpack_public_path__ + "d03fa26234272af487f6978a6d271fb5.glb";